import React, { Component } from 'react';

export default class Steps extends Component{

    render() {
        // this component receives the configuration array in this format
        /* [
            {
            completeStatus:true/false,
            title:"Title of the step"
            },
             {
            completeStatus:true/false,
            title:"Title of the step"
            },
             {
            completeStatus:true/false,
            title:"Title of the step"
            },
        ]*/
        let stepsGrid = this.props.stepArray.map(function(stepData,index){

            // let classNameVariable = stepData.completeStatus ? "step-item complete" : "step-item active";
            let classNameVariable = "";
            if (stepData.isSelected && !stepData.completeStatus){
                classNameVariable = "step-item active";
            }
            else if (!stepData.isSelected && stepData.completeStatus){
                classNameVariable = "step-item complete";
            }
            else if (!stepData.isSelected && !stepData.completeStatus){
                classNameVariable = "step-item";
            }

            return (<li className={classNameVariable} key={`step${index}`}>
                <a href="javascript:void(0);" className="step-link">
                    <span className="step-number">{index+1}</span>
                    <span className="step-title">{stepData.title}</span>
                </a>
            </li>)
        })

        return (
            <ul className="steps steps-sm mg-y-10">
                {stepsGrid}
            </ul>
        )
    }
}